import React from "react";
import HubspotNewsletterSignUpForm from "../hubspot-forms/newsletter-signup-form";

export default function NewsletterSignup() {
  return (
    <section className="bg-paua-deep-purple flex w-full items-center justify-center py-14 2xl:py-20 ">
      <div className="flex-col justify-center items-center pt-8 mx-auto w-full sm:w-3/4 lg:w-full">

        <HubspotNewsletterSignUpForm />
        <div className="w-11/12 lg:w-9/12 border-b opacity-30 pt-16 flex justify-center mx-auto border-very-light-purple"></div>
      </div>
      
    </section>
  );
}
